export const HOME = "/";
export const SIGN_UP = "/sign-up";
export const SIGN_IN = "/sign-in";
export const LOG_OUT = "/logout";
export const TOKENS = "/tokens";
export const SUBSCRIPTION = "/subscription";
export const DASHBOARD = "/dashboard";
export const GET_STARTED = "/get-started";
export const INVOICES = "/invoices";
export const ADMIN_USERS = "/admin/users";
export const ADMIN_PRODUCTS = "/admin/products";
export const ADMIN_SUBSCRIPTIONS = "/admin/subscriptions";
export const ADMIN_CONTACT_SALES = "/admin/contact-sales";
